<template>
  <div class="nav">
    <div class="nav_item" @click="to('/home')">
      <img src="@/assets/首页-灰色.png" v-show="currentIndex !== 0" >
      <img src="@/assets/首页.png" v-show="currentIndex === 0">
      <div :class="{red:currentIndex === 0}">首页</div>
    </div>
    <!-- <div class="nav_item" @click="to('/')">
      <img src="@/assets/京东-灰色.png" v-show="currentIndex !== 1">
      <img src="@/assets/京东.png" v-show="currentIndex === 1">
      <div :class="{red:currentIndex === 1}">京东</div>
    </div>
    <div class="nav_item" @click="to('/')">
      <img src="@/assets/唯品会-灰色.png" v-show="currentIndex !== 2">
      <img src="@/assets/唯品会.png" v-show="currentIndex === 2">
      <div :class="{red:currentIndex === 2}">唯品会</div>
    </div>
    <div class="nav_item" @click="to('/')">
      <img src="@/assets/躺赚-灰色.png" v-show="currentIndex !== 3">
      <img src="@/assets/躺赚.png" v-show="currentIndex === 3">
      <div :class="{red:currentIndex === 3}">躺赚神器</div>
    </div> -->
    <div class="nav_item" @click="to('/')">
        <img src="@/assets/我的-灰色.png" v-show="currentIndex !== 4">
        <img src="@/assets/我的.png" v-show="currentIndex === 4">
      <div :class="{red:currentIndex === 4}">我的</div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      currentIndex: 0
    }
  },
  created () {

    if(this.$route.path === '/home'){
      this.currentIndex = 0
    }else if(this.$route.path === '/'){
      this.currentIndex = 4
    }
  },
  methods:{
    to(path){
      this.$router.push(path)
      
    }
  }
}
</script>

<style lang="less" scoped>
.nav{
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  text-align: center;
  bottom: 0;
  width: 100vw;
  height: 6rem;
  font-size: 1.4rem;
  font-family: PingFangSC-Regular;
  letter-spacing: 0;
  z-index: 9999; 
  background-color: #fff;
  color: #999999;
  .nav_item{
    width: 50vw;
  }
  img{
    
    width: 3.6rem;
    height: 3.6rem;
  }
  .red{
    color: #F63A25;
  }
}
</style>